import { EtheriumIcon } from "shared/src/icons/crypto/EtheriumIcon";
import { BitcoinIcon } from "shared/src/icons/crypto/BitcoinIcon";
import { USDCIcon } from "shared/src/icons/crypto/USDCIcon";
import { USDTIcon } from "shared/src/icons/crypto/USDTIcon";
import { RadixQuestionMarkIcon } from "shared/src/icons/RadixQuestionMarkIcon";

type Props = {
  cryptoCode: string;
  className: string | undefined;
};

export const CryptoFlag = ({ cryptoCode, className }: Props) => {
  switch (cryptoCode.toLowerCase()) {
    case "eth":
      return <EtheriumIcon className={className} />;
    case "btc":
      return <BitcoinIcon className={className} />;
    case "usdc":
      return <USDCIcon className={className} />;
    case "usdt":
      return <USDTIcon className={className} />;
    default:
      return <RadixQuestionMarkIcon className={className} />;
  }
};
